// extracted by mini-css-extract-plugin
export default {"select-item":"message-field-selector_select-item__ikmBy","select":"message-field-selector_select__ozOcf"};